import Vue from 'vue';

// v-focusで要素にフォーカスを当てる
Vue.directive('focus', {
    inserted(el, binding, vnode) {
        // v-focus="false"の時はフォーカス当てない
        if (binding.hasOwnProperty('value') && !binding.value) {
            return;
        }
        el.focus();
    }
});

// 要素の外側のクリックイベント
Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = e => {
            if (!(el === e.target || el.contains(e.target))) {
                vnode.context[binding.expression](e);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});
